export default __webpack_public_path__ + "static/media/nepal_clients_receiving_contraceptives.435af4bd.jpg";